"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'user.profile.title': 'Edit Profile',
    'user.profile.back': 'Back to Dashboard',
    'user.profile.name.label': 'Full Name',
    'user.profile.name.placeholder': 'John Doe',
    'user.profile.username.label': 'Username',
    'user.profile.username.placeholder': 'johndoe',
    'user.profile.email.label': 'Email',
    'user.profile.email.placeholder': 'email@address.com',
    'user.profile.picture.label': 'Profile Picture',
    'user.profile.picture.placeholder': 'Choose a profile picture...',
    'user.profile.picture.remove': '×',
    'user.profile.changePassword.title': 'Change Password',
    'user.profile.changePassword.description': 'Leave password fields empty if you don\'t want to change your password.',
    'user.profile.password.new.label': 'New Password',
    'user.profile.password.placeholder': 'Enter new password',
    'user.profile.password.repeat.label': 'Repeat New Password',
    'user.profile.password.repeat.placeholder': 'Repeat new password',
    'user.profile.submit': 'Update Profile',
    'user.profile.form.passwordMismatch': 'Passwords do not match',
    'user.profile.form.updateFailed': 'Failed to update profile',
    'user.profile.form.updateSuccess': 'Profile updated successfully',
};
